import { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../../api/API_SERVERS";
import { IoDocumentTextOutline, IoDownloadOutline } from "react-icons/io5";

export default function AdForm({ fetchAds, loading, setLoading }) {
    const getTodayDateString = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const getOneMonthLaterString = (startDateStr) => {
        const date = startDateStr ? new Date(startDateStr) : new Date();
        date.setMonth(date.getMonth() + 1);
        return date.toISOString().split('T')[0];
    };

    const [formData, setFormData] = useState({
        size: "small",
        title: "",
        text: "",
        image_url: "",
        link_url: "",
        person_id: "",
        fullname: "",
        price: "40",
        started_at: getTodayDateString() || "",
        expires_at: getOneMonthLaterString(getTodayDateString()) || "",
        priority_level: "0",
        phone: "", // <-- ახალი სთეითი
        email: ""  // <-- ახალი სთეითი
    });

    useEffect(() => {
        if (formData.priority_level === "1") {
            setFormData((prev) => ({ ...prev, price: "600" }));
        } else {
            const basePrices = { small: "40", medium: "90", big: "150" };
            setFormData((prev) => ({ ...prev, price: basePrices[prev.size] || "0" }));
        }
    }, [formData.size, formData.priority_level]);

    const setPresetInterval = (type) => {
        const start = new Date(formData.started_at);
        if (type === "month") {
            start.setMonth(start.getMonth() + 1);
        } else if (type === "year") {
            start.setFullYear(start.getFullYear() + 1);
        }
        setFormData(prev => ({ ...prev, expires_at: start.toISOString().split('T')[0] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const payload = {
                size: formData.size,
                title: formData.title,
                text: formData.text,
                image_url: formData.image_url,
                link_url: formData.link_url,
                person_id: formData.person_id,
                fullname: formData.fullname,
                price: parseFloat(formData.price),
                started_at: formData.started_at,
                expires_at: formData.expires_at,
                priority_level: parseInt(formData.priority_level, 10),
                phone: formData.phone || null, // <-- გადაეცემა ბექენდს
                email: formData.email || null  // <-- გადაეცემა ბექენდს
            };

            await axios.post(API_URL + "/api/admin/ads", payload, {
                headers: { Authorization: `Bearer ${localStorage.getItem("AdminToken")}` }
            });

            // ფორმის გასუფთავება
            setFormData({
                size: "small",
                title: "",
                text: "",
                image_url: "",
                link_url: "",
                person_id: "",
                fullname: "",
                price: "40",
                started_at: getTodayDateString(),
                expires_at: getOneMonthLaterString(getTodayDateString()),
                priority_level: "0",
                phone: "",
                email: ""
            });

            await fetchAds();
            alert("სარეკლამო ხელშეკრულება წარმატებით გაფორმდა!");
        } catch (err) {
            console.error("დეტალური შეცდომა:", err.response?.data);
            alert("შეცდომა რეკლამის დამატებისას: " + (err.response?.data?.message || "სერვერის შეცდომა"));
        } finally {
            setLoading(false);
        }
    };

    const handleDownloadDraftPDF = () => {
        const printWindow = window.open("", "_blank");

        const sizeTranslations = { small: "მცირე (Small 150x150)", medium: "საშუალო (Medium 400x150)", big: "დიდი (Big 1000x200)" };
        const prioTranslations = { "0": "სტანდარტული (დონე 0)", "1": "პრიორიტეტული (დონე 1)", "2": "ჩაკეტილი 100% (დონე 2)", "3": "მონოპოლია (დონე 3)" };

        printWindow.document.write(`
            <html lang="ka">
            <head>
                <title>შეთანხმების პროექტი - Teacher Hub</title>
                <style>
                    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 40px; color: #1e293b; line-height: 1.6; }
                    .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #4f46e5; padding-bottom: 20px; margin-bottom: 30px; }
                    .logo { font-size: 26px; font-weight: 800; color: #4f46e5; text-decoration: none; }
                    .doc-title { text-align: center; text-transform: uppercase; margin: 30px 0; font-size: 18px; font-weight: 700; color: #0f172a; letter-spacing: 0.5px; }
                    .parties-container { display: flex; justify-content: space-between; gap: 40px; margin-bottom: 30px; }
                    .party-box { flex: 1; border: 1px solid #e2e8f0; padding: 16px; border-radius: 8px; background-color: #f8fafc; }
                    .party-title { font-weight: 700; font-size: 14px; color: #4f46e5; border-bottom: 1px solid #cbd5e1; padding-bottom: 6px; margin-bottom: 10px; text-transform: uppercase; }
                    .party-row { font-size: 13px; margin: 4px 0; }
                    .party-row strong { color: #475569; }
                    .section-title { font-size: 14px; font-weight: 700; color: #0f172a; margin-top: 30px; margin-bottom: 10px; border-bottom: 1px solid #e2e8f0; padding-bottom: 4px; }
                    .grid-details { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 20px; }
                    .detail-card { border: 1px solid #e2e8f0; padding: 12px; border-radius: 6px; background: #fff; }
                    .detail-card span { display: block; font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; }
                    .detail-card p { margin: 4px 0 0 0; font-size: 14px; font-weight: 600; color: #0f172a; }
                    .invoice-summary { background: #eef2ff; border: 1px solid #c7d2fe; border-radius: 8px; padding: 15px 20px; display: flex; justify-content: space-between; align-items: center; margin: 25px 0; }
                    .invoice-label { font-weight: 700; color: #3730a3; font-size: 14px; }
                    .invoice-price { font-size: 22px; font-weight: 800; color: #4f46e5; }
                    .terms-section { font-size: 12px; border: 1px solid #e2e8f0; padding: 15px; border-radius: 8px; background-color: #f8fafc; color: #475569; }
                    .terms-title { font-weight: 700; margin-bottom: 6px; color: #0f172a; }
                    .signatures { display: flex; justify-content: space-between; margin-top: 60px; align-items: flex-start; }
                    .sig-block { display: flex; flex-direction: column; align-items: center; width: 250px; }
                    .sig-line { border-top: 1px solid #475569; width: 100%; text-align: center; padding-top: 8px; font-size: 12px; font-weight: 600; color: #475569; }
                    .digital-stamp { border: 2px dashed #4f46e5; background: #f5f3ff; color: #4f46e5; padding: 8px 12px; border-radius: 6px; font-family: 'Courier New', monospace; font-size: 10px; font-weight: bold; text-align: center; margin-bottom: 8px; line-height: 1.4; }
                    .footer { margin-top: 50px; font-size: 11px; color: #64748b; border-top: 1px solid #e2e8f0; padding-top: 15px; text-align: center; }
                </style>
            </head>
            <body>
                <div class="header">
                    <a href="https://www.teacherhub.ge" class="logo">TEACHER HUB</a>
                    <div style="font-size: 13px; color: #64748b;">თარიღი: ${new Date().toLocaleDateString('ka-GE')}</div>
                </div>

                <div class="doc-title">სარეკლამო მომსახურების შეთანხმების პროექტი</div>

                <div class="parties-container">
                    <div class="party-box">
                        <div class="party-title">მომწოდებელი</div>
                        <div class="party-row"><strong>კომპანია:</strong> Teacher Hub Georgia</div>
                        <div class="party-row"><strong>ვებ-გვერდი:</strong> www.teacherhub.ge</div>
                        <div class="party-row"><strong>სტატუსი:</strong> სარეკლამო პლატფორმა</div>
                    </div>
                    <div class="party-box">
                        <div class="party-title">დამკვეთი</div>
                        <div class="party-row"><strong>სახელი, გვარი:</strong> ${formData.fullname || "N/A"}</div>
                        <div class="party-row"><strong>პირადი ნომერი:</strong> ${formData.person_id || "N/A"}</div>
                        <div class="party-row"><strong>მობილური:</strong> ${formData.phone || "N/A"}</div> <div class="party-row"><strong>ელ-ფოსტა:</strong> ${formData.email || "N/A"}</div>   </div>
                </div>

                <div class="section-title">სარეკლამო კამპანიის პარამეტრები</div>
                <div class="grid-details">
                    <div class="detail-card">
                        <span>ბანერის ზომა და ტიპი</span>
                        <p>${sizeTranslations[formData.size] || formData.size}</p>
                    </div>
                    <div class="detail-card">
                        <span>პრიორიტეტის დონე</span>
                        <p>${prioTranslations[formData.priority_level] || formData.priority_level}</p>
                    </div>
                    <div class="detail-card">
                        <span>კამპანიის დაწყება</span>
                        <p>${formData.started_at}</p>
                    </div>
                    <div class="detail-card">
                        <span>კამპანიის დასრულება</span>
                        <p>${formData.expires_at}</p>
                    </div>
                </div>

                <div class="section-title">სარეკლამო მასალა (კონტენტი)</div>
                <div class="grid-details" style="grid-template-columns: 1fr;">
                    <div class="detail-card">
                        <span>ბანერის სათაური</span>
                        <p>${formData.title || "N/A"}</p>
                    </div>
                    <div class="detail-card" style="margin-top: -5px;">
                        <span>მოკლე სარეკლამო აღწერა</span>
                        <p style="font-weight: normal; font-size: 13px; color: #475569;">${formData.text || "N/A"}</p>
                    </div>
                    <div class="detail-card" style="margin-top: -5px;">
                        <span>სამიზნე ბმული (Redirect URL)</span>
                        <p style="font-size: 12px; color: #4f46e5; word-break: break-all;">${formData.link_url || "N/A"}</p>
                    </div>
                </div>

                <div class="invoice-summary">
                    <span class="invoice-label">მომსახურების ჯამური ღირებულება:</span>
                    <span class="invoice-price">₾${Number(formData.price).toFixed(2)} GEL</span>
                </div>

                <div class="terms-section">
                    <div class="terms-title">წესები და პირობები:</div>
                    1. სარეკლამო მომსახურება აქტიურდება ხელშეკრულებაში მითითებულ დაწყების თარიღში.<br>
                    2. მომსახურების დაწყების შემდგომ, გადახდილი თანხა უკან დაბრუნებას არ ექვემდებარება. დამკვეთის ინიციატივით კამპანიის ნაადრევად შეწყვეტის/წაშლის შემთხვევაში, გადახდილი საფასური სრულად რჩება პროვაიდერთან.
                </div>

                <div class="signatures">
                    <div class="sig-block">
                        <div class="digital-stamp">
                            ✓ ავტორიზებული ელ-ხელმოწერა<br>
                            პროვაიდერი: TEACHER HUB GEORGIA<br>
                            ბმული: https://www.teacherhub.ge<br>
                            დოკუმენტი: პროექტი / დრაფტი
                        </div>
                        <div class="sig-line">მომწოდებელი (Teacher Hub)</div>
                    </div>
                    <div class="sig-block" style="justify-content: flex-end; height: 105px;">
                        <div class="sig-line">დამკვეთის ხელმოწერა</div>
                    </div>
                </div>

                <div class="footer">
                    თიჩერ ჰაბი საქართველო © ${new Date().getFullYear()} - წინასწარი დოკუმენტის გენერატორი
                </div>
                <script>
                    window.onload = function() { window.print(); window.close(); }
                </script>
            </body>
            </html>
        `);
        printWindow.document.close();
    };

    return (
        <div className="am-ad-form-section document-layout-container" style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "16px", padding: "2.5rem", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)" }}>
            <div className="am-ad-form-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "2px solid var(--border)", paddingBottom: "1.5rem", marginBottom: "2rem" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <IoDocumentTextOutline size={28} color="var(--primary)" />
                    <div>
                        <h3 style={{ margin: 0, fontSize: "1.25rem" }}>სარეკლამო შეთანხმების გაფორმება</h3>
                        <span style={{ fontSize: "0.85rem", color: "var(--text-muted)" }}>ახალი კამპანიის მონაცემები და პროექტი</span>
                    </div>
                </div>
                <button type="button" onClick={handleDownloadDraftPDF} className="ui-page-btn" style={{ display: "flex", alignItems: "center", gap: "8px", background: "#f1f5f9", color: "#1e293b", border: "1px solid #cbd5e1" }}>
                    <IoDownloadOutline size={18} />
                    პროექტის PDF ჩამოტვირთვა
                </button>
            </div>

            <form onSubmit={handleSubmit} className="am-form-grid">
                {/* დამკვეთის ბლოკი */}
                <div className="am-input-group">
                    <label>დამკვეთის პირადი ნომერი / ს/კ</label>
                    <input className="ui-search-input" type="text" required placeholder="11-ნიშნა კოდი..." value={formData.person_id} onChange={(e) => setFormData({ ...formData, person_id: e.target.value })} />
                </div>
                <div className="am-input-group">
                    <label>დამკვეთის სახელი და გვარი</label>
                    <input className="ui-search-input" type="text" required placeholder="სახელი, გვარი..." value={formData.fullname} onChange={(e) => setFormData({ ...formData, fullname: e.target.value })} />
                </div>

                {/* ახალი: მობილურის ნომერი და ელ-ფოსტა */}
                <div className="am-input-group">
                    <label>მობილურის ნომერი</label>
                    <input className="ui-search-input" type="tel" placeholder="მაგ: 599XXXXXX..." value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
                </div>
                <div className="am-input-group">
                    <label>ელ-ფოსტა</label>
                    <input className="ui-search-input" type="email" placeholder="მაგ: client@example.com..." value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
                </div>

                {/* პარამეტრების ბლოკი */}
                <div className="am-input-group">
                    <label>ბანერის ზომა</label>
                    <select className="ui-search-input" required value={formData.size} onChange={(e) => setFormData({ ...formData, size: e.target.value })}>
                        <option value="small">მცირე ბანერი (Small 150x150)</option>
                        <option value="medium">საშუალო ბანერი (Medium 400x150)</option>
                        <option value="big">დიდი ბანერი (Big 1000x200)</option>
                    </select>
                </div>
                <div className="am-input-group">
                    <label>პრიორიტეტის დონე</label>
                    <select className="ui-search-input" required value={formData.priority_level} onChange={(e) => setFormData({ ...formData, priority_level: e.target.value })}>
                        <option value="0">სტანდარტული (დონე 0)</option>
                        <option value="1">დონე 1 - პრიორიტეტული (600₾)</option>
                        <option value="2">დონე 2 - ჩაკეტილი (100% Lock)</option>
                        <option value="3">დონე 3 - სრული მონოპოლია (Takeover)</option>
                    </select>
                </div>

                <div className="am-input-group">
                    <label>დაწყების თარიღი</label>
                    <input className="ui-search-input" type="date" name="started_at" required value={formData.started_at || ""} onChange={(e) => setFormData({ ...formData, started_at: e.target.value })} />
                </div>

                <div className="am-input-group">
                    <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        დასრულების თარიღი
                        <div style={{ display: "flex", gap: "6px" }}>
                            <button type="button" onClick={() => setPresetInterval("month")} className="ui-mini-btn" style={{ fontSize: "10px", padding: "2px 6px", background: "#f1f5f9", border: "1px solid #cbd5e1", borderRadius: "4px", cursor: "pointer" }}>+1 თვე</button>
                            <button type="button" onClick={() => setPresetInterval("year")} className="ui-mini-btn" style={{ fontSize: "10px", padding: "2px 6px", background: "#f1f5f9", border: "1px solid #cbd5e1", borderRadius: "4px", cursor: "pointer" }}>+1 წელი</button>
                        </div>
                    </label>
                    <input className="ui-search-input" type="date" name="expires_at" required value={formData.expires_at || ""} onChange={(e) => setFormData({ ...formData, expires_at: e.target.value })} />
                </div>

                <div className="am-input-group">
                    <label>ღირებულება (₾)*</label>
                    <input className="ui-search-input" type="number" required min="0" placeholder="თანხა ლარში" value={formData.price} onChange={(e) => setFormData({ ...formData, price: e.target.value })} />
                </div>
                <div className="am-input-group">
                    <label>ბანერის სათაური</label>
                    <input className="ui-search-input" type="text" required placeholder="Ad Title..." value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} />
                </div>
                <div className="am-input-group">
                    <label>გადასასვლელი ლინკი (URL)</label>
                    <input className="ui-search-input" type="url" required placeholder="https://..." value={formData.link_url} onChange={(e) => setFormData({ ...formData, link_url: e.target.value })} />
                </div>
                <div className="am-input-group">
                    <label>მოკლე სარეკლამო ტექსტი</label>
                    <input className="ui-search-input" type="text" required maxLength="50" placeholder="ტექსტი ბანერისთვის..." value={formData.text} onChange={(e) => setFormData({ ...formData, text: e.target.value })} />
                </div>
                <div className="am-input-group span-2">
                    <label>სურათის ლინკი (Image URL)</label>
                    <input className="ui-search-input" type="url" required placeholder="სურათის პირდაპირი ბმული..." value={formData.image_url} onChange={(e) => setFormData({ ...formData, image_url: e.target.value })} />
                </div>
                <button type="submit" className="ui-page-btn primary" disabled={loading} style={{ gridColumn: "span 2", marginTop: "1rem" }}>
                    {loading ? "რეგისტრირდება..." : "ატვირთვა"}
                </button>
            </form>
        </div>
    );
}